<h2 translate class="text-center">MATRIX_DISCOUNTS</h2>
<lib-filter-list [configService]="configService"></lib-filter-list>
